<template>
    <div class="card config-section">
        <CardHeader
            title="Parâmetros Administrativos"
            icon="fas fa-user-shield"
        />
        <div class="card-body">
            <div class="section-form">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input
                                    id="admin_edit"
                                    type="checkbox"
                                    class="custom-control-input"
                                    :checked="value.admin_edit"
                                    @change="updateField('admin_edit', $event.target.checked)"
                                />
                                <label
                                    class="custom-control-label"
                                    for="admin_edit"
                                >
                                    <div class="switch-content">
                                        <i class="fas fa-edit mr-2"></i>
                                        <div>
                                            <strong>Administrador pode editar cadastros</strong>
                                            <small class="d-block text-muted">
                                                Permite edição de cadastros por administradores
                                            </small>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardHeader from "../../Base/CardHeader.vue";

export default {
    name: 'AdminConfig',
    components: {CardHeader},
    props: {
        value: {type: Object, required: true},
    },
    methods: {
        updateField(field, newValue) {
            this.$emit('update', field, newValue);
        }
    }
};
</script>

<style scoped>
/* Custom Switch */
.custom-control-input:checked ~ .custom-control-label::before {
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.custom-control-label {
    position: relative;
    margin-bottom: 0;
    padding-left: 2rem;
}

.switch-content {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.switch-content i {
    margin-top: 2px;
    color: #17a2b8;
}
</style>



// WEBPACK FOOTER //
// src/components/Parameters/components/AdminConfig.vue